module.exports = __webpack_public_path__ + "static/media/hero.202d5b6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/img/hero.svg
// module id = 327
// module chunks = 0